import { httpsCallable } from 'firebase/functions';
import { useAppDispatch, useAppSelector } from '../../../../../hooks';
import { functions } from '../../../../../config/firebase';
import {
    setFormDataReducer,
    submitRegistrationFailureReducer,
    submitRegistrationStartReducer,
    submitRegistrationSuccessReducer,
    clearRegistrationErrorReducer,
    resetRegistrationStateReducer
} from '../slice/SearchLinkSlice';
import {
    SearchLinkFormInterface,
    ResponseSearchLinkInterface
} from '../../domain';

const useSearchLinkInfrastructure = () => {
    const dispatch = useAppDispatch();
    const searchLinkState = useAppSelector(state => state.searchLink);

    const getReferralLinkByPhoneCallable = httpsCallable<SearchLinkFormInterface, ResponseSearchLinkInterface>(functions, 'getReferralLinkByPhone');


    const setFormDataInfrastructure = (formData: Partial<SearchLinkFormInterface>) => {
        dispatch(setFormDataReducer(formData));
    }

    const submitRegistrationInfrastructure = async () => {
        dispatch(submitRegistrationStartReducer());
        try {
            // El SDK de Firebase envuelve esto en un objeto { data: ... } automáticamente.
            // No necesitamos hacerlo nosotros.
            const result = await getReferralLinkByPhoneCallable(searchLinkState.formData);
            dispatch(submitRegistrationSuccessReducer(result.data));
            return result.data;
        } catch (err) {
            dispatch(submitRegistrationFailureReducer());
        }
    };

    const clearRegistrationErrorInfrastructure = () => {
        dispatch(clearRegistrationErrorReducer());
    }

    const resetRegistrationStateInfrastructure = () => {
        dispatch(resetRegistrationStateReducer());
    }

    return {
        setFormDataInfrastructure,
        submitRegistrationInfrastructure,
        clearRegistrationErrorInfrastructure,
        resetRegistrationStateInfrastructure,
        searchLinkState
    }
}

export default useSearchLinkInfrastructure;